/**
 * @generated SignedSource<<918e7d976e6ff445178d6967be078b01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EventSelectorQuery$variables = {
  excludeSeriesMembers?: boolean | null | undefined;
  excludedIds?: ReadonlyArray<string> | null | undefined;
  q: string;
  writableOnly: boolean;
};
export type EventSelectorQuery$data = {
  readonly events: {
    readonly items?: ReadonlyArray<{
      readonly audioOnly: boolean;
      readonly created: string;
      readonly creators: ReadonlyArray<string>;
      readonly description: string | null | undefined;
      readonly duration: number;
      readonly endTime: string | null | undefined;
      readonly id: string;
      readonly isLive: boolean;
      readonly seriesId: string | null | undefined;
      readonly seriesTitle: string | null | undefined;
      readonly startTime: string | null | undefined;
      readonly thumbnail: string | null | undefined;
      readonly title: string;
    }>;
  };
};
export type EventSelectorQuery = {
  response: EventSelectorQuery$data;
  variables: EventSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "excludeSeriesMembers"
},
v1 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "excludedIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "writableOnly"
},
v4 = [
  {
    "kind": "Variable",
    "name": "excludeSeriesMembers",
    "variableName": "excludeSeriesMembers"
  },
  {
    "kind": "Variable",
    "name": "excludedIds",
    "variableName": "excludedIds"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "q"
  },
  {
    "kind": "Variable",
    "name": "writableOnly",
    "variableName": "writableOnly"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchEvent",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "seriesId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "seriesTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creators",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "audioOnly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventSearchResults",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSelectorQuery",
    "selections": [
      {
        "alias": "events",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "searchAllEvents",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "EventSelectorQuery",
    "selections": [
      {
        "alias": "events",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "searchAllEvents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1f108248b8af5fae67e46dae0a0c0901",
    "id": null,
    "metadata": {},
    "name": "EventSelectorQuery",
    "operationKind": "query",
    "text": "query EventSelectorQuery(\n  $q: String!\n  $excludeSeriesMembers: Boolean = false\n  $excludedIds: [String!] = []\n  $writableOnly: Boolean!\n) {\n  events: searchAllEvents(query: $q, writableOnly: $writableOnly, excludeSeriesMembers: $excludeSeriesMembers, excludedIds: $excludedIds) {\n    __typename\n    ... on EventSearchResults {\n      items {\n        id\n        title\n        seriesId\n        seriesTitle\n        creators\n        thumbnail\n        isLive\n        created\n        duration\n        startTime\n        endTime\n        audioOnly\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "547700ba11f6b0c03e95db9de132b7bc";

export default node;
